export class AiBuilderData {
  public id: number;
  public title: string;
  public link: any;
  public modifiedDate: Date;
  public postedDate: Date;
  public createdWith: string;
  public templateType: string;
  public conditionCount: number;
  public pageType: string;
  public frontPage: boolean;
  public kitPage: boolean;
  public kitSettings: any;
  public pageStatus: 'draft' | 'published';
}
